export default "__VITE_ASSET__DYK6rjoL__"